import React from "react";
import { Download } from "lucide-react";

interface ExportButtonProps {
  label: string;
  onClick: () => void;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ label, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50"
    >
      <Download className="h-3.5 w-3.5" />
      {label}
    </button>
  );
};
